// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_dashboard_hints_decisionacceptedsingleproductratio4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage of positions with exactly one product match that was correct`)
};

const en_us2_dashboard_hints_decisionacceptedsingleproductratio4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage of positions with exactly one product match that was correct`)
};

const de_de2_dashboard_hints_decisionacceptedsingleproductratio4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteil der Positionen mit genau einem Produkttreffer, der korrekt war`)
};

const en_dashboard_hints_decisionacceptedsingleproductratio4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage of positions with exactly one product match that was correct`)
};

const de_dashboard_hints_decisionacceptedsingleproductratio4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteil der Positionen mit genau einem Produkttreffer, der korrekt war`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const dashboard_hints_decisionacceptedsingleproductratio4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dashboard_hints_decisionacceptedsingleproductratio4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dashboard_hints_decisionacceptedsingleproductratio4", locale)
	if (locale === "en-GB") return en_gb2_dashboard_hints_decisionacceptedsingleproductratio4(inputs)
	if (locale === "en-US") return en_us2_dashboard_hints_decisionacceptedsingleproductratio4(inputs)
	if (locale === "de-DE") return de_de2_dashboard_hints_decisionacceptedsingleproductratio4(inputs)
	if (locale === "en") return en_dashboard_hints_decisionacceptedsingleproductratio4(inputs)
	return de_dashboard_hints_decisionacceptedsingleproductratio4(inputs)
};
export { dashboard_hints_decisionacceptedsingleproductratio4 as "dashboard.hints.decisionAcceptedSingleProductRatio" }